import { RouterProvider } from "react-router-dom";
import { router } from "./AppRoutes";
import HeaderComponent from "./Components/HeaderComponent";
import { useHeader } from "./Providers/HeaderContextProvider";
import { Toaster } from "react-hot-toast";

function Layout() {
  const { headerContent, headerContentRightSideContent, profileContent, isCoachingActive } =
    useHeader();

  return (
    <>
      {headerContent && (
        <HeaderComponent
          headerContentRightSideContent={headerContentRightSideContent}
          profileContent={profileContent}
          isCoachingActive={isCoachingActive}
        />
      )}
      <RouterProvider router={router} />
      <Toaster
        position={"top-right"}
        toastOptions={{
          duration: 3000,
        }}
        // Offset below the header, which is a full-width bar at z-index 1000:
        // at top-right the toast would otherwise land behind the notification
        // bell. (Irrelevant while these sat at bottom-center.)
        containerStyle={{ zIndex: 1100, top: 72 }}
      />
    </>
  );
}

export default Layout;
